import React from 'react'
import EyefinitySectionFields from '../EyefinitySectionFields'

export default function Exams(props) {
  return <EyefinitySectionFields {...props} sectionName="exams" title="Exams" />
}
